import { StyleSheet } from 'react-native';
import {
  fontFamilyBold,
  bold,
  fontFamilySemiBold,
  fontSizeLarge,
  fontSizeMedium,
  purple,
  defaultWidth,
  editLinkColor,
} from '../../constants/palette';

const styles = StyleSheet.create({
  addSessionLink: {
    color: purple,
    fontSize: fontSizeMedium,
    fontFamily: fontFamilySemiBold,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  card: {
    margin: 10,
  },

  sessionCardsContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  title: {
    fontFamily: fontFamilyBold,
    fontSize: fontSizeLarge,
    marginRight: 20,
    marginBottom: -15,
  },
  plainText: {
    fontSize: 14,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  artistDataErrorText: {
    fontSize: fontSizeMedium,
    width: defaultWidth,
    textAlign: 'center',
  },
  createButtonContainer: {
    marginTop: 25,
  },
  editLinkText: {
    color: editLinkColor,
    fontWeight: bold,
    fontSize: fontSizeMedium,
  },
  errorContainer: {
    justifyContent: 'center',
    paddingTop: 20,
    alignItems: 'center',
  },
});

export default styles;
